import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcode";
import { DOMAIN } from "../../global";
import headerImage from "../image/visibleSafety/new_letterhead.png";
import footerImage from "../image/visibleSafety/footer_VCC1.png";
import vssLogo from "../image/visibleSafety/watermark.png";

let config = {
  margin: 20,
  borderMagin: 3,
  fontSize: 7.5,
  bordergap: 3,
  currentY: 0,
  headerHeight: 80,
  footerheight: 40
};

const generateStaticSection = (doc, formInfo, inputStates, extraprops) => {
  const is13 = formInfo?.name?.includes("Section-29");
  const bgColor = "FFFFFF";
  const textColor = "#000000";

  const parsedTitle = formInfo?.title ? JSON.parse(formInfo.title) : {};
  const rule = parsedTitle?.rule || "";
  const title = parsedTitle?.title || "";

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [40, 60];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  // First row - Title section with background color
  autoTable(doc, {
    startY: config.headerHeight + 5,
    margin: { left: config.margin, right: config.margin },
    theme: "plain",
    body: [
      [
        {
          content: `Certificate No.-${extraprops?.certificateNo || ""}`,
          //   colSpan: 4,
          styles: {
            halign: "left",
            fontSize: config.fontSize + 2,
          },
        },
        {
          content: `${
            formInfo?.branchId == 15
              ? "Competency No:- CMP-618/2023 ,  Dated:08/01/2024 Valid up to 31/12/2024"
              : ""
          }`,
          //   colSpan: 4,
          styles: {
            halign: "left",
            fontSize: config.fontSize + 2,
          },
        },
      ],
    ],
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0,
      valign: "middle",
      fontStyle: "italic",
      cellPadding: { top: 2, bottom: 2, left: 0, right: 2 },
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
    },
  });

  // Second TableRow: Report number, right-aligned
  autoTable(doc, {
    startY: doc.lastAutoTable?.finalY + 2,
    body: [
      [
        {
          content: (formInfo?.name || "").toUpperCase(),
          styles: {
            fillColor: bgColor,
            textColor: textColor,
            halign: "center",
            valign: "middle",
            fontStyle: "bolditalic",
            fontSize: config.fontSize + 3,
            cellPadding: { top: 7, bottom: 2, left: 5, right: 5 },
          },
        },
      ],
      //   [
      //     {
      //       content: rule,
      //       styles: {
      //         fillColor: bgColor,
      //         textColor: textColor,
      //         halign: "center",
      //         valign: "middle",
      //         fontStyle: "bold",
      //         fontSize: config.fontSize,
      //         cellPadding: { top: 2, bottom: 2, left: 5, right: 5 },
      //       },
      //     },
      //   ],
      //   [
      //     {
      //       content: title,
      //       styles: {
      //         fillColor: bgColor,
      //         textColor: textColor,
      //         halign: "center",
      //         valign: "middle",
      //         fontStyle: "bolditalic", // applies bold and italic
      //         fontSize: config.fontSize,
      //         cellPadding: { top: 2, bottom: 5, left: 5, right: 5 },
      //       },
      //     },
      //   ],
    ],
    theme: "plain",
    margin: { left: config.margin + 95, right: config.margin + 95 },
    didDrawCell: function (data) {
      if (data.section === 'body') {
        const cell = data.cell;
        const text = cell.text;
        // Get font properties
        doc.setFont(doc.getFont().fontName, 'bolditalic');
        doc.setFontSize(config.fontSize + 3);        
        // Calculate line height
        const lineHeight = (config.fontSize + 3) * 1;
        // Draw underline for each line of text
        text.forEach((line, index) => {
          if (line.trim()) {
            const textWidth = doc.getTextWidth(line);
            const startX = cell.x + (cell.width - textWidth) / 2; // Center aligned
            const lineY = cell.y + cell.styles.cellPadding.top + (index + 1) * lineHeight + 1;            
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.5);
            doc.line(startX, lineY, startX + textWidth, lineY);
          }
        });
      }
    }
  });
};

const generateDynamicTableSection = (
  doc,
  filteredInputFields,
  inputStates,
  Factory,
  Shop,
  Product
) => {
  const body = [];

  filteredInputFields?.forEach((field) => {
    if (field?.stateKey === "companyName") return;
    if (field?.stateKey === "certificateNumber" || field?.stateKey === "conclusionOfCertificate" || field?.stateKey === "inspectedOn") return;

    let label = field?.label || "";
    const numberMatch = label.match(/^\d+(\.\s|[a-z]\) )/);
    const number = numberMatch ? numberMatch[0].trim() : "";
    let restLabel = label.replace(number, "").trim();
    if (restLabel === "Address of the Factory") {
      restLabel = "Name and address of the Factory";
    }

    let value = "";

    if (field?.stateKey === "factoryId") {
      const factory = Factory?.find((ele) => ele.id === inputStates?.factoryId);
      value = `${factory?.name || ""}\n${inputStates?.factoryId || ""}`;
    } else if (field?.stateKey === "shopId") {
      const shop = Shop?.find((ele) => ele.id === inputStates?.shopId);
      value = shop?.name || "";
    } else if (field?.stateKey === "equipmentId") {
      const product = Product?.find(
        (ele) => ele.id === inputStates?.equipmentId
      );
      value = product?.name || "";
    } else if (field?.type === "DatePicker") {
      const date = inputStates?.[field?.stateKey];
      value = date ? new Date(date).toLocaleDateString("en-GB") : "";
    } else {
      value = inputStates?.[field?.stateKey] || "";
    }

    body.push([
      {
        content: number,
        styles: {
          //   fillColor: "#d9d9d9",
          halign: "center",
          valign: "middle",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2 },
        },
      },
      {
        content: restLabel,
        styles: {
          //   fillColor: "#fff2cd",
          halign: "left",
          valign: "middle",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2, left: 5 },
        },
      },
      {
        content: ":",
        styles: {
          //   fillColor: "#d9d9d9",
          halign: "center",
          valign: "middle",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2 },
        },
      },
      {
        content: value,
        styles: {
          //   fillColor: "#fff2cd",
          halign: "left",
          valign: "middle",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2, left: 5 },
        },
      },
    ]);
  });

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [2, 48, 2, 48];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  autoTable(doc, {
    startY: doc.lastAutoTable?.finalY + 5,
    margin: { left: config.margin, right: config.margin },
    body: body,
    theme: "plain",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0,
      valign: "middle",
      fontStyle: "italic",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
  });
};

const generateSignatureSectionPDF = async ({
  doc,
  inputStates,
  extraprops,
  formInfo,
}) => {
  const getFormattedDate = () => {
    const today = inputStates?.inspectedOn
      ? new Date(inputStates?.inspectedOn)
      : new Date();
    return today.toLocaleDateString("en-GB");
  };

  const getNextYearDate = () => {
    const today = inputStates?.reportDate
      ? new Date(inputStates?.reportDate)
      : new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);
    const formattedNextYearDate = inputStates?.certificateValidity
      ? moment(inputStates?.certificateValidity).format("DD/MM/YYYY")
      : "00/00/0000";

    return formattedNextYearDate;
  };

  const paragraphText =
    // formInfo?.name !== "Form13"
    //   ?
    `Inspected on: ${getFormattedDate()} ` + inputStates["conclusionOfCertificate"]?.trim();

  // const officeAddress =
  //   "3SM TECH SOLUTION\nOffice # 301, Samyak Galleria, Near Divisional Sports Complex,\nSutgirani Chowk, Garkheda Rd, Aurangabad, Maharashtra - 431009";
  const finalY = doc.lastAutoTable.finalY + 2;
  autoTable(doc, {
    startY: finalY,
    margin: { left: config.margin, right: config.margin },
    body: [
      [
        {
          content: paragraphText,
          styles: {
            halign: "justify",
            cellPadding: 2,
            fontStyle: "italic",
          },
        },
      ],
      [
        {
          content: `Next inspection due on: ${getNextYearDate()}`,
          styles: {
            halign: "justify",
            cellPadding: 1,
            fontStyle: "bolditalic",
          },
        },
      ],
    ],
    theme: "plain",
    styles: {
      fontSize: config.fontSize + 1.7,
    },
  });

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [10, 39, 2, 19, 40];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  // Generate QR code BEFORE the autoTable
  const qrCodeUrl = `${DOMAIN}/#/printForm/${extraprops.newReportID}/${extraprops.newTemplateID}/print`;
  let qrCodeDataUrl;
  
  try {
    qrCodeDataUrl = await QRCode.toDataURL(qrCodeUrl, { 
      width: 200, 
      height: 200,
      margin: 1
    });
  } catch (err) {
    console.error("QR Code generation error:", err);
  }

  // Prepare autoTable
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 3,
    margin: { left: config.margin, right: config.margin },
    body: [
      [
        {
          content: "",
          rowSpan: 4,
          styles: { fillColor: false, halign: "left" },
        },
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        {
          content: "",
          styles: {
            minCellHeight: 20,
          },
        },
        {
          content: "",
          rowSpan: 6,
          styles: {
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
    ],
    theme: "plain",
    styles: {
      fontSize: config.fontSize,
      cellPadding: { top: 2, left: 5, bottom: 2, right: 5 },
      valign: "middle",
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0,
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
    },

    didDrawCell: (data) => {
      if (data.column.index === 4) {
        let { x, y, width, height } = data.cell;
        x= /Section[- ]29/.test(formInfo?.name || "") ? x-20 : x;
        console.log({ x, y, width, height })
        const imageSize = height;
        const centerX = x + (width - imageSize) / 2;
        const centerY = y + (height - imageSize) / 2;

        doc.addImage(
          extraprops?.stamLogo || "",
          "PNG",
          centerX,
          centerY,
          imageSize + 15,
          imageSize
        );

        // Draw text below the image
        const textX = x + width / 2;
        const textY = centerY + imageSize + 8; // Adjust spacing below image

        doc.setFontSize(config.fontSize + 1);
        doc.setFont(undefined, "bolditalic");
        doc.text(extraprops?.competentPerson?.personName, textX, textY, {
          align: "center",
        });

        doc.setFont(undefined, "bolditalic");
        doc.setFontSize(config.fontSize + 1);
        doc.text("Competent Person" + "\n" + extraprops?.competentPerson?.qualification, textX, textY + 8, {
          align: "center",
        });
      }
      // sign img
      //   if (
      //     data.column.index === 3 &&
      //     data.row.index === 0 &&
      //     selectedOption?.signPath
      //   ) {
      //     const { x, y, width, height } = data.cell;
      //     const imageSize = height - 5;
      //     const centerX = x + 5;
      //     const centerY = y + (height - imageSize) / 2;

      //     doc.addImage(
      //       selectedOption?.signPath || "",
      //       "PNG",
      //       centerX,
      //       centerY,
      //       imageSize + 50,
      //       imageSize
      //     );
      //   }

      //   qr code
      if (data.column.index === 0 && data.row.index === 0 && qrCodeDataUrl) {
        const { x, y, width, height } = data.cell;
        const imageSize = height;
        const centerX = x + (width - imageSize) / 2;
        const centerY = y + (height - imageSize) / 2;

            doc.addImage(
              qrCodeDataUrl,
              "PNG",
              centerX + 10,
              centerY + 10,
              imageSize - 10,
              imageSize - 10
        );
      }
    },
  });
};

export async function generatePDF1(
  formInfo,
  inputStates,
  filteredInputFields,
  Factory,
  Shop,
  Product,
  extraprops
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });

config.fontSize = /Section[- ]29/.test(formInfo?.name || "") ? 11.5 : 7.5;


  //   const totalWidth = doc.internal.pageSize.getWidth();
  //   const totalHeight = doc.internal.pageSize.getHeight();
  //   doc.setDrawColor(0);
  //   doc.setLineWidth(0.3);
  //   doc.rect(
  //     config?.borderMagin + 2,
  //     config?.borderMagin + config.bordergap,
  //     totalWidth - config?.borderMagin * 2 - 2,
  //     totalHeight - config?.borderMagin * 2 - config.bordergap
  //   );
const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
   // === 1. Add Header Image ===
   const reducedMargin = config.margin / 2 - 10;

  doc.addImage(
    headerImage,
    "PNG",
    reducedMargin,
    0,
    pageWidth - reducedMargin * 2,
    config.headerHeight
  );

  // === 2. Add Footer Image ===
  doc.addImage(
    footerImage,
    "PNG",
    reducedMargin,
    pageHeight - config.footerheight,
    pageWidth -reducedMargin * 2,
    config.footerheight
  );

  // === 3. Add Center Logo ===
  const logoWidth = 300;
  const logoHeight = 150;
  const centerX = (pageWidth - logoWidth) / 2;
  const centerY = (pageHeight - logoHeight) / 2;

  doc.addImage(vssLogo, "PNG", centerX, centerY, logoWidth, logoHeight);

  generateStaticSection(doc, formInfo, inputStates, extraprops);

  generateDynamicTableSection(
    doc,
    filteredInputFields,
    inputStates,
    Factory,
    Shop,
    Product
  );

  await generateSignatureSectionPDF({
    doc,
    inputStates,
    extraprops,
    formInfo,
  });

  doc.save(`form.pdf`);
}
